import React from "react";
import "./LoadingSpinner.css";
export const LoadingSpinner = () => (
  <div className="loadingSpinner">
    <div />
    <div />
    <div />
    <div />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js